import React from 'react';

const About = () => {
  return (
    <div className="about-container">
      <h1>About Us</h1>
      <p>We are a team dedicated to providing valuable content and information.</p>
      <p>Our mission is to educate and inform readers on various topics.</p>
    </div>
  );
};

export default About;